/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Suggestions_Welcome_10Inputs */

const es_chat_suggestions_welcome_10 = /** @type {(inputs: Chat_Suggestions_Welcome_10Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hola ${i?.name}. ¿En qué puedo asistirte?`)
};

const en_chat_suggestions_welcome_10 = /** @type {(inputs: Chat_Suggestions_Welcome_10Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hello ${i?.name}. How can I assist you?`)
};

/**
* | output |
* | --- |
* | "Hello {name}. How can I assist you?" |
*
* @param {Chat_Suggestions_Welcome_10Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_suggestions_welcome_10 = /** @type {((inputs: Chat_Suggestions_Welcome_10Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestions_Welcome_10Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_suggestions_welcome_10(inputs)
	return en_chat_suggestions_welcome_10(inputs)
});
export { chat_suggestions_welcome_10 as "chat.suggestions.welcome_10" }